import React from "react";
import ProductView from "./ProductView";
import ProductInfo from "./ProductInfo";
import { Link } from "react-router-dom";
import ArrowRight from "../../../assets/svg/ArrowRight";

const ProductTopWrapper = ({ product }) => {
  return (
    <div className="pt-[70px] max-sm:pt-14">
      {/* breadcrumb section */}
      <div className="flex items-start justify-between max-sm:justify-end  mb-4">
        <div className="flex items-center gap-2 max-sm:hidden">
          <Link
            to="/"
            className="text-[14px] text-[#4A4C56] leading-[21px] hover:text-[#016FFC] transition-colors font-medium"
          >
            Home
          </Link>
          <ArrowRight />
          <Link
            to="/product"
            className="text-[14px] text-[#4A4C56] leading-[21px] hover:text-[#016FFC] transition-colors font-medium"
          >
            Product
          </Link>
          <ArrowRight />
          <span className="text-[14px] text-[#4A4C56] hover:text-[#016FFC] transition-colors  font-medium">
            {product?.title}
          </span>
        </div>
      </div>

      {/* product section */}
      <div className="flex max-sm:flex-col gap-10 max-[450px]:gap-6">
        <div className="">
          <ProductView product={product} />
        </div>
        <div className="flex gap-x-[85px] max-xl:gap-x-[60px] gap-y-[24px] flex-col md:flex-col lg:flex-row w-full justify-between">
          <ProductInfo product={product} />
        </div>
      </div>
    </div>
  );
};

export default ProductTopWrapper;
